module.exports = __webpack_public_path__ + "img/gxjs.42dea2ba.png";